import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { spaceL } = theme();

  return StyleSheet.create({
    horizontal: {
      flexDirection: "row",
      flex: 1,
      gap: spaceL,
    },
    horizontalChild: {
      flex: 1,
    },
  });
};

export { style };
